import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { MenuComponent } from 'src/common-ui/menu/menu.component';
import getAdvancedSettingsMenuItems from './advanced-settings-menu-items';
const AdvancedSettingsPage = ({}) => {
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_ADVANCED}-page`, className: "advanced-settings-page" },
        React.createElement(MenuComponent, { title: "popup_html_advanced_settings", isBackButtonEnable: true, menuItems: getAdvancedSettingsMenuItems() })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const AdvancedSettingsPageComponent = connector(AdvancedSettingsPage);
